import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _23mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"23mp"}/>
}
